import React from "react";
import { connect } from "react-redux";
import { withStyles } from "@material-ui/core/styles";
import Modal from "@material-ui/core/Modal";
import Button from "@material-ui/core/Button";
import {
    selectShowAddEventModal,
    selectClickedTimeBlock,
    selectDateForClickedTimeBlock,
    selectTracks,
    selectDayRange,
    selectJobpacks,
    selectJobpackNamesForAddEventList,
    selectJobpackKeys,
    selectResourceForClickedTimeblock,
    selectResourceNamesForAddEventList,
    selectResourceKeys,
    selectAgendaItemDragging
} from "../redux/selectors";
import { CirclePicker } from "react-color";
import Typography from "@material-ui/core/Typography";

import { closeAddEventModal, createTask, setAgendaItemDragging } from "../redux/actions";
import Card from "@material-ui/core/Card";
import CardActions from "@material-ui/core/CardActions";
import CardHeader from "@material-ui/core/CardHeader";
import CardContent from "@material-ui/core/CardContent";
import EventDayRangePicker from "./EventDayRangePicker";
import Input from "@material-ui/core/Input";
import InputLabel from "@material-ui/core/InputLabel";
import FormControl from "@material-ui/core/FormControl";
import Select from "@material-ui/core/Select";
import MenuItem from "@material-ui/core/MenuItem";

import moment from "moment";
function getModalStyle() {
    return {
        top: `50%`,
        left: `50%`,
        transform: `translate(-50%, -50%)`,
        overflow: "visible"
    };
}

const styles = theme => ({
    paper: {
        position: "absolute",
        width: theme.spacing.unit * 55,
        backgroundColor: theme.palette.background.paper,
        boxShadow: theme.shadows[5],
        padding: theme.spacing.unit,
        overflow: "visible"
    },

    margin: {
        margin: theme.spacing.unit
    }
});

class AddEventModal extends React.Component {
    constructor(props) {
        super(props);

        this.state = {
            start_date: "",
            end_date: "",
            id: "",
            name: "",
            jobpack_key: "",
            resource_key: false,
            assigned_task_key: false,
            jobnameIndex: 0,
            resourceNameIndex: 0,
            color: "#f44336",
            row: false
        };
    }

    handleClose = () => {
        this.props.closeAddEventModal();
    };

    getNextAssignedTaskKey = (resource, key) => {
        let taskKey = "000000";
        if (resource["assigned_tasks"]) {
            const numbers = Object.keys(resource["assigned_tasks"]).map(e => {
                return parseInt(e, 10);
            });

            const newNumber = Math.max(...numbers) + 1;

            taskKey = `${newNumber}`.padStart(6, "0");
        }

        return taskKey;
    };

    componentDidUpdate(prevProps) {
        if (this.props.show !== prevProps.show) {
            if (this.props.show === true) {
                let name = "";
                let resourceNameIndex = 0;

                if (
                    this.props.agendaItemDragging !== false &&
                    typeof this.props.agendaItemDragging.item.name !== "undefined"
                ) {
                    name = this.props.agendaItemDragging.item.name;
                    resourceNameIndex = this.props.resourceNameList.indexOf(name);
                } else {
                    name = this.props.resourceNameList
                        ? this.props.resourceNameList[0]
                        : this.props.jobpackNameList[0];
                }

                this.setState({
                    ...this.state,
                    id: "",
                    name,
                    jobpack_key: "",
                    resource_key: false,
                    assigned_task_key: false,
                    type: "",
                    // jobnameIndex: 0,
                    resourceNameIndex,
                    row: this.props.clickedTimeBlock.row + 1
                });

                this.props.setAgendaItemDragging(false, false);
            }
        }
    }

    render() {
        const { classes } = this.props;

        if (!this.props.resource.data) {
            return (
                <div>
                    <Modal
                        aria-labelledby="simple-modal-title"
                        aria-describedby="simple-modal-description"
                        open={this.props.show}
                        onClose={this.handleClose}
                    >
                        <Card style={getModalStyle()} className={classes.paper}>
                            <CardHeader title={"Add Event"} />

                            <CardContent>
                                {" "}
                                <Typography variant="body1" gutterBottom>
                                    No resources available for this track
                                </Typography>
                            </CardContent>
                            <CardActions className={classes.actions} disableActionSpacing>
                                <Button
                                    inactive={"" + (this.state.color === "")}
                                    href="#text-buttons"
                                    className={classes.button}
                                    onClick={() => {
                                        this.props.closeAddEventModal();
                                    }}
                                >
                                    Close
                                </Button>
                            </CardActions>
                        </Card>
                    </Modal>
                </div>
            );
        }
        return (
            <div>
                <Modal
                    aria-labelledby="simple-modal-title"
                    aria-describedby="simple-modal-description"
                    open={this.props.show}
                    onClose={this.handleClose}
                >
                    <Card style={getModalStyle()} className={classes.paper}>
                        <CardHeader title={"Add Event"} />

                        <CardContent>
                            <EventDayRangePicker
                                initialDates={this.props.clickedTimeBlockDate}
                                setDayRange={(from, to) => {
                                    const start_date = moment(from)
                                        .format("DD/MM/YYYY")
                                        .toString();
                                    const end_date = moment(to)
                                        .format("DD/MM/YYYY")
                                        .toString();
                                    this.setState({
                                        ...this.state,
                                        start_date,
                                        end_date
                                    });
                                }}
                                open={this.props.show}
                            />

                            <FormControl className={classes.margin}>
                                <InputLabel htmlFor="input-with-icon-adornment">Name</InputLabel>
                                <Input
                                    id="input-with-icon-adornment"
                                    value={this.state.name}
                                    onChange={e => {
                                        this.setState({
                                            ...this.state,
                                            name: e.target.value
                                        });
                                    }}
                                />
                            </FormControl>

                            <FormControl className={classes.margin}>
                                <InputLabel htmlFor="jobname">Job Name</InputLabel>
                                <Select
                                    value={this.state.jobnameIndex}
                                    onChange={e => {
                                        if (this.props.resourceNameList) {
                                            this.setState({
                                                ...this.state,
                                                jobnameIndex: e.target.value
                                            });
                                        } else {
                                            this.setState({
                                                ...this.state,
                                                jobnameIndex: e.target.value,
                                                name: this.props.jobpackNameList[e.target.value]
                                            });
                                        }
                                    }}
                                    inputProps={{
                                        name: "Job Name",
                                        id: "jobname"
                                    }}
                                >
                                    {this.props.jobpackNameList.map((e, i) => {
                                        return (
                                            <MenuItem key={i} value={i}>
                                                {e}
                                            </MenuItem>
                                        );
                                    })}
                                </Select>
                            </FormControl>
                            {this.props.resourceNameList && (
                                <FormControl className={classes.margin}>
                                    <InputLabel htmlFor="resourceName">
                                        {this.props.resource.type}
                                    </InputLabel>
                                    <Select
                                        value={this.state.resourceNameIndex}
                                        onChange={e => {
                                            this.setState({
                                                ...this.state,
                                                resourceNameIndex: e.target.value,
                                                name: this.props.resourceNameList[e.target.value]
                                            });
                                        }}
                                        inputProps={{
                                            name: "Resource Name",
                                            id: "resourceName"
                                        }}
                                    >
                                        {this.props.resourceNameList.map((e, i) => {
                                            return (
                                                <MenuItem key={i} value={i}>
                                                    {e}
                                                </MenuItem>
                                            );
                                        })}
                                    </Select>
                                </FormControl>
                            )}
                            <div style={{ marginTop: "10px" }}>
                                <CirclePicker
                                    color={this.state.color}
                                    width="400px"
                                    onChangeComplete={color =>
                                        this.setState({
                                            ...this.state,
                                            color: color.hex
                                        })
                                    }
                                />
                            </div>
                        </CardContent>
                        <CardActions className={classes.actions} disableActionSpacing>
                            <Button
                                inactive={"" + (this.state.color === "")}
                                href="#text-buttons"
                                className={classes.button}
                                onClick={e => {
                                    this.props.closeAddEventModal();
                                    const task = this.state;
                                    task.id = Date.now();
                                    task.id = task.id.toString();
                                    task.jobpack_key = this.props.jobpackKeys[
                                        this.state.jobnameIndex
                                    ];
                                    task.row = this.state.row;

                                    if (this.props.resource.type !== "jobpack") {
                                        const resourceKey = this.props.resourceKeys[
                                            this.state.resourceNameIndex
                                        ];
                                        task.resource_key = `${
                                            this.props.resource.path
                                        }/${resourceKey}`;

                                        const resourceData = this.props.resource.data[resourceKey];

                                        task.assigned_task_key = this.getNextAssignedTaskKey(
                                            resourceData
                                        );
                                    }

                                    task.type = this.props.clickedTimeBlock.type;

                                    this.props.createTask(
                                        task,
                                        this.props.clickedTimeBlock,
                                        this.props.tracks,
                                        this.props.dayRange.start
                                    );
                                }}
                            >
                                Add
                            </Button>
                        </CardActions>
                    </Card>
                </Modal>
            </div>
        );
    }
}

export default withStyles(styles)(
    connect(
        store => {
            return {
                show: selectShowAddEventModal(store),
                clickedTimeBlock: selectClickedTimeBlock(store),
                clickedTimeBlockDate: selectDateForClickedTimeBlock(store),
                tracks: selectTracks(store),
                dayRange: selectDayRange(store),
                jobpacks: selectJobpacks(store),
                jobpackNameList: selectJobpackNamesForAddEventList(store),
                jobpackKeys: selectJobpackKeys(store),
                resource: selectResourceForClickedTimeblock(store),
                resourceNameList: selectResourceNamesForAddEventList(store),
                resourceKeys: selectResourceKeys(store),
                agendaItemDragging: selectAgendaItemDragging(store)
            };
        },
        { closeAddEventModal, createTask, setAgendaItemDragging }
    )(AddEventModal)
);
